import { render, staticRenderFns } from "./chemical-permeation.vue?vue&type=template&id=40f4aa7f&"
import script from "./chemical-permeation.vue?vue&type=script&lang=js&"
export * from "./chemical-permeation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports